import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import {
  seleccionarCampo,
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  onCambioMoneda,
  calcularTotales,
  cmbCedula,
  comboprecios,
  validarCantidad,
  round,
  lpad,
  onCambioUnidadTres,
  calcularTotalesDos,
  validarCantidadTres,
  validarPrecioMontos,
} from "../../util/varios";
import moment from "moment";
import CatalogoProductoExistencia from "../../catalogos/catalogoProductoExistencia";
import useTableScroll from "../useTableScroll";
import CatalogoFactura from "../../catalogos/catalogoFactura";
import CatalogoNotaEntregaFacturas from "../../catalogos/catalogoNotaEntregaFactura";

const TablaFacturaxNota = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtnfacturas = JSON.parse(sessionStorage.getItem("accbtnfacturaxnotasc"));

  const txtNumFactura = useRef();
  const txtPrecio = useRef([]);
  const txtFecha = useRef();
  const txtId = useRef([]);
  const txtIdproducto = useRef([]);
  const txtCantidad = useRef([]);
  const btnIncluir = useRef();
  const btnEditar = useRef();
  const btnEliminar = useRef();
  const btnConsultar = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtNombreC = useRef();
  const txtSubTotal = useRef();
  const txtExentoTotal = useRef();
  const txtDescuento = useRef();
  const txtTotIva = useRef();
  const txtTotal = useRef();
  const cmbMoneda = useRef();
  const txtFechaVencimiento = useRef();
  const txtDireccioncliente = useRef();
  const txtIdcliente = useRef();

  const [body, setBody] = useState(null);
  const [operacion, setOperacion] = useState(0);
  const [habilitado, setHabilitado] = useState(false);
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitadoCli, setHabilitadoCli] = useState(false);
  const [selectd, setSelectd] = useState(0);
  const [selectp, setSelectp] = useState(0);
  const [habilitadoProductos, setHabilitadoProductos] = useState(true);
  const [habilitadoMod, setHabilitadoMod] = useState(false);
  const [habilitadoTip, setHabilitadoTip] = useState(false);
  const [indice, setIndice] = useState(null);
  const [visible, setVisible] = useState(0);
  const [mostrar, setMostrar] = useState(false);
  const [habilitarMoneda, setHabilitarMoneda] = useState(false);
  const [records, setRecords] = useState([]);
  const [combomoneda, setComboMoneda] = useState([]);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Facturas.");
  const [catalogoFactura, setCatalogoFactura] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [totales, setTotales] = useState({
    subtotal: 0.0,
    descuento: 0.0,
    exento: 0.0,
    sujeto: 0.0,
    iva: 16.0,
    totaliva: 0.0,
    total: 0.0,
  });
  const [idsnotas, setIdnotas] = useState([]);
  const [catalogoNota, setCatalogoNota] = useState(false);
  const [activate, setActivate] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [factura, setFactura] = useState({
    idfactura: "0",
    numfactura: "000000",
    cedularif: "",
    descripcion: "FACTURA DE PRODUCTOS",
    totalmonto: 0.0,
    totaliva: 0.0,
    totaldescuento: 0.0,
    totalexento: 0.0,
    totalsujeto: 0.0,
    idcliente: "",
    idvendedor: "",
    fecha: moment(fechasistema).format("YYYY-MM-DD"),
    status: 0,
    idalmacen: "",
    idmoneda: "",
    idoperacioninventario: "",
    idnotaentrega: "",
    numnotaentrega: "",
    creditof: false,
    fechavencimientof: moment(fechasistema).format("YYYY-MM-DD"),
    valormoneda: 0.0,
  });
  const [cliente, setCliente] = useState({
    idcliente: "",
    tiporif: "J",
    rif: "",
    nombre: "",
  });
  const [vendedor, setVendedor] = useState({
    idvendedor: "",
    tiporif: "",
    rif: "",
    nombre: "",
    idalmacen: "",
  });

  let nomtabla;

  if (operacion === 4 || operacion === 3) {
    nomtabla = [
      { label: "COD-PRODUCTO", textAlign: "center", width: "30px" },
      { label: "PRODUCTO", textAlign: "center", width: "250px" },
      { label: "CANTIDAD", textAlign: "center", width: "20px" },
      { label: "PRECIO", textAlign: "center", width: "50px" },
      { label: "IVA.", textAlign: "center", width: "50px" },
      { label: "MONTO IVA", textAlign: "center", width: "50px" },
      { label: "MONTO TOTAL", textAlign: "center", width: "50px" },
    ];
  } else {
    nomtabla = [
      { label: "COD-PRODUCTO", textAlign: "center", width: "30px" },
      { label: "PRODUCTO", textAlign: "center", width: "250px" },
      { label: "CANTIDAD", textAlign: "center", width: "20px" },
      { label: "PRECIO", textAlign: "center", width: "50px" },
      { label: "IVA.", textAlign: "center", width: "50px" },
      { label: "MONTO IVA", textAlign: "center", width: "50px" },
      { label: "MONTO TOTAL", textAlign: "center", width: "50px" },
      {
        label: <i className="fas fa-trash" />,
        textAlign: "center",
        width: "20px",
      },
    ];
  }

  const headCells = nomtabla;

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let x = 0;
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
              } else if (response.data[i].predeterminada) {
                setMoneda(response.data[i]);
                setMonedaCambio({
                  idmoneda: response.data[i].idmoneda,
                  descripcion: response.data[i].descripcion,
                  simbolo: response.data[i].simbolo,
                  predeterminada: response.data[i].predeterminada,
                  subpredeterminada: response.data[i].subpredeterminada,
                  valormoneda: 1.0,
                });
                x = i;
              }
            }
          }
          setTimeout(() => (cmbMoneda.current.selectedIndex = x), 200);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const selectnumfactu = () => {
    let tabla = "factura";
    let id = "idfactura";
    let idtabla = "idfactura";
    let endpoint = `${op.conexion}/api/inventario/consultacodigos?tabla=${tabla}&idtabla=${idtabla}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.numeroasignado > 0) {
            let to = parseFloat(response.data.numeroasignado) + 1;
            let cerrrou = '000000';
            let paddedNumber = lpad(to.toString(), cerrrou, 6);
            txtNumFactura.current.value = "F" + paddedNumber;
            if (txtNumFactura.current.value !== '') {
              setTimeout(() => txtNumFactura.current.focus(), 200);
            }
          } else {
            txtNumFactura.current.value = "F000001";
            if (txtNumFactura.current.value !== '') {
              setTimeout(() => txtNumFactura.current.focus(), 200);
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarVendedor = (id) => {
    let campos =
      "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
    let nomtab = "agente as v";
    let nomid = "v.idagente";
    let nomid2 = "v.vendedor";
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setVendedor({
              idvendedor: response.data.idagente,
              tiporif: response.data.tiporifv,
              rif: response.data.rifv,
              nombre: response.data.nombrev,
              idalmacen: response.data.idalmacen,
            });

            btnAcepta.current.focus();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un vendedor con este codigo",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarProducto = (index, idubi, idprod) => {
    let endpoint = `${op.conexion}/api/pedido/seleccionarproductoinv?idproducto=${idprod}&idalmacen=${idubi}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = [...records];
          if (response.data !== "") {
            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "no existe un producto con ese codigo en el almacen.",
                icono: "error",
              });
              txtCantidad.current[records.length - 1].value = "1,00";
            } else {
              for (let i = 0; i < records.length; i++) {
                if (records[i].idproducto === response.data.idproducto) {
                  setActivate(false);
                  setMensaje({
                    mostrar: true,
                    titulo: "Notificacion",
                    texto: "el producto ya ha sido seleccionado.",
                    icono: "error",
                  });
                  return;
                }
              }

              let uni = [];
              let precio = 0.0;
              let montoiva = 0.0;
              let cantie = response.data.cantidad;
              let tipouni = 0;
              let tiene_iva = false;
              let tipoprecio = parseInt(response.data.tipoprecio);

              if (parseFloat(response.data.ivaventa) > 0.0) {
                tiene_iva = true;
              }

              if (
                parseInt(response.data.tipofactor) === 0 ||
                response.data.tipofactor === null
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie = parseFloat(response.data.cantidad);
                cantie = Math.trunc(cantie);

                if (tipoprecio === 1) {
                  precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
                } else if (tipoprecio === 2) {
                  precio = parseFloat(response.data.precioofe) * monedaSub.valormoneda;
                } else if (tipoprecio === 3) {
                  precio = parseFloat(response.data.preciomayor) * monedaSub.valormoneda;
                } else if (tipoprecio === 4) {
                  precio = parseFloat(response.data.preciomini) * monedaSub.valormoneda;
                }

              } else {
                if (
                  response.data.idunidadventa === response.data.idunidadalterna
                ) {
                  tipouni = 1;
                  uni = [
                    {
                      idunidad: response.data.idunidadalterna,
                      descripcion: response.data.descripcionunialt,
                      tipo: "alterna",
                    },
                    {
                      idunidad: response.data.idunidadmedida,
                      descripcion: response.data.descripcionuni,
                      tipo: "medida",
                    },
                  ];

                  cantie = parseFloat(response.data.cantidad);
                  cantie = Math.trunc(cantie);
                  if (tipoprecio === 1) {
                    precio = parseFloat(response.data.preciomaxialter) * monedaSub.valormoneda;
                  } else if (tipoprecio === 2) {
                    precio = parseFloat(response.data.precioofealter) * monedaSub.valormoneda;
                  } else if (tipoprecio === 3) {
                    precio = parseFloat(response.data.preciomayoralter) * monedaSub.valormoneda;
                  } else if (tipoprecio === 4) {
                    precio = parseFloat(response.data.preciominialter) * monedaSub.valormoneda;
                  }

                } else if (
                  response.data.idunidadventa === response.data.idunidadmedida
                ) {
                  tipouni = 0;
                  uni = [
                    {
                      idunidad: response.data.idunidadmedida,
                      descripcion: response.data.descripcionuni,
                      tipo: "medida",
                    },
                    {
                      idunidad: response.data.idunidadalterna,
                      descripcion: response.data.descripcionunialt,
                      tipo: "alterna",
                    },
                  ];

                  cantie = parseFloat(
                    response.data.cantidad / response.data.valorfactor
                  );
                  cantie = Math.trunc(cantie);

                  if (tipoprecio === 1) {
                    precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
                  } else if (tipoprecio === 2) {
                    precio = parseFloat(response.data.precioofe) * monedaSub.valormoneda;
                  } else if (tipoprecio === 3) {
                    precio = parseFloat(response.data.preciomayor) * monedaSub.valormoneda;
                  } else if (tipoprecio === 4) {
                    precio = parseFloat(response.data.preciomini) * monedaSub.valormoneda;
                  }

                }
              }

              montoiva = (precio * response.data.ivaventa) / 100;
              montoiva = round(montoiva, 2);

              if (index !== null) {
                data[index] = {
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  nombre: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"}`,
                  iva: response.data.ivaventa,
                  precio: precio,
                  cantidad: 1.0,
                  totalivas: montoiva,
                  totalsiniva: precio,
                  totalmonto: precio + montoiva,
                  tipounidad: tipouni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  unidad: uni,
                  valorfactor: response.data.valorfactor
                };
              } else {
                data.push({
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  nombre: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"}`,
                  iva: response.data.ivaventa,
                  precio: precio,
                  cantidad: 1.0,
                  totalivas: montoiva,
                  totalsiniva: precio,
                  totalmonto: precio + montoiva,
                  tipounidad: tipouni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  unidad: uni,
                  valorfactor: response.data.valorfactor
                });
              }

              setRecords(data);
              setTotales(calcularTotalesDos(data));
              setIndice(index);

              if (index !== null) {
                setTimeout(() => txtCantidad.current[index].focus(), 300);
              } else {
                setTimeout(
                  () => txtCantidad.current[data.length - 1].focus(),
                  300
                );
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "no existe un producto con ese codigo en el almacen.",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarNotaEntrega = (datos) => {
    let ids = [];
    let idsnots = [];
    for (let i = 0; i < datos.length; i++) {
      ids.push(parseInt(datos[i].idnota));
      idsnots.push({
        idnota: parseInt(datos[i].idnota)
      });
    }
    setIdnotas(idsnots);
    let endpoint = `${op.conexion}/api/registropago/selectnotaentregafactuid?ids=${ids}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {

          let datapropduct = [];
          let datos = [];

          for (let i = 0; i < response.data.length; i++) {

            datapropduct.push({
              idproducto: response.data[i].idproducto,
              codigo: response.data[i].codigoproductoc,
              nombre: response.data[i].nombreproducto,
              tipounidad: response.data[i].tipounidadc,
              idunidadmedida: response.data[i].idunidadmedida,
              idunidadalterna: response.data[i].idunidadalterna,
              unidadmedida: response.data[i].unidadmedida,
              iva: response.data[i].iva,
              precio: parseFloat(response.data[i].precios),
              montoiva: parseFloat(response.data[i].montoivac),
              cantidad: parseFloat(response.data[i].cantidadc),
              cantidadc: parseFloat(response.data[i].cantidadcaja),
              cantidadunic: parseFloat(response.data[i].cantiunidxcaja),
              totalsiniva: parseFloat(response.data[i].totalsiniva),
              totalmonto: parseFloat(response.data[i].total),
              valorfactor: parseFloat(response.data[i].valorfactor)
            });

          }

          console.log("datapropduct", datapropduct);

          const unificarProductos = [];
          for (const product of datapropduct) {
            const existingProduct = unificarProductos.find((p) => p.nombre === product.nombre);
            if (existingProduct) {
              existingProduct.totalmonto += parseFloat(product.totalmonto);
              existingProduct.cantidad += parseFloat(product.cantidad);
              existingProduct.cantidadc += parseFloat(product.cantidadc);
              existingProduct.cantidadunic += parseFloat(product.cantidadunic);
              existingProduct.totalsiniva += parseFloat(product.totalsiniva);
            } else {
              unificarProductos.push({ ...product });
            }
          }

          let subtotaln = 0.00;
          let exenton = 0.00;
          let sujeton = 0.00;
          let totalivan = 0.00;
          let totaln = 0.00;
          let uni = [];

          for (let e = 0; e < unificarProductos.length; e++) {

            let precioproduct = 0.00;
            let totalcantidad = 0;
            let montoconiva = 0.00;
            let montototal = 0.00;
            let moniva = 0.00;
            let totaliva = 0.00;
            let tipouni = null;


            if (unificarProductos[e].cantidad > 0 && unificarProductos[e].cantidadc > 0) {
              precioproduct = round(unificarProductos[e].totalsiniva / (unificarProductos[e].cantidad + unificarProductos[e].cantidadunic), 2);
              totalcantidad = unificarProductos[e].cantidad + unificarProductos[e].cantidadunic;
              moniva = (precioproduct * unificarProductos[e].iva) / 100;
              totaliva = round(moniva * totalcantidad, 2);
              montoconiva = round((precioproduct + moniva) * totalcantidad, 2);
              montototal = round(precioproduct * totalcantidad, 2);
              tipouni = 1;
            } else if (unificarProductos[e].cantidad > 0 && unificarProductos[e].cantidadc === 0) {
              precioproduct = round(unificarProductos[e].totalsiniva / unificarProductos[e].cantidad, 2);
              totalcantidad = unificarProductos[e].cantidad;
              moniva = (precioproduct * unificarProductos[e].iva) / 100;
              totaliva = round(moniva * totalcantidad, 2);
              montoconiva = round((precioproduct + moniva) * totalcantidad, 2);
              montototal = round(precioproduct * totalcantidad, 2);
              tipouni = 1;
            } else {
              precioproduct = round(unificarProductos[e].totalsiniva / unificarProductos[e].cantidadc, 2);
              totalcantidad = unificarProductos[e].cantidadc;
              moniva = (precioproduct * unificarProductos[e].iva) / 100;
              totaliva = round(moniva * totalcantidad, 2);
              montoconiva = round((precioproduct + moniva) * totalcantidad, 2);
              montototal = round(precioproduct * totalcantidad, 2);
              tipouni = 0;
            }

            if (tipouni === 1) {
              uni = [{
                idunidad: unificarProductos[e].idunidadalterna,
                descripcion: "UNIDAD",
                tipo: "alterna",
              },
              {
                idunidad: unificarProductos[e].idunidadmedida,
                descripcion: unificarProductos[e].unidadmedida,
                tipo: "medida",
              },
              ];
            } else {
              uni = [{
                idunidad: unificarProductos[e].idunidadmedida,
                descripcion: unificarProductos[e].unidadmedida,
                tipo: "medida",
              },
              {
                idunidad: unificarProductos[e].idunidadalterna,
                descripcion: "UNIDAD",
                tipo: "alterna",
              },

              ];
            }

            totaln = totaln + montoconiva;
            sujeton = sujeton + totaliva;
            totalivan = totalivan + totaliva;

            if (unificarProductos[e].iva > 0) {
              subtotaln = subtotaln + montototal;
            } else {
              exenton = exenton + montototal;
            }


            datos.push({
              idproducto: unificarProductos[e].idproducto,
              codigo: unificarProductos[e].codigo,
              nombre: unificarProductos[e].nombre,
              iva: unificarProductos[e].iva,
              precio: precioproduct,
              cantidad: totalcantidad,
              totalivas: totaliva,
              totalsiniva: montototal,
              totalmonto: montoconiva,
              tipounidad: tipouni,
              idunidadmedida: unificarProductos[e].idunidadmedida,
              idunidadalterna: unificarProductos[e].idunidadalterna,
              unidad: uni,
              valorfactor: unificarProductos[e].valorfactor
            });

          }
          setRecords(datos);
          setTotales({
            subtotal: subtotaln + exenton,
            descuento: 0.0,
            exento: exenton,
            sujeto: subtotaln,
            iva: 16.0,
            totaliva: round(totalivan, 2),
            total: totaln,
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarFactura = () => {
    const campos =
      "p.*, m.*, p.fecha as fechafactura, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc, c.direccion as direccionc";
    const nomtab =
      "factura as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";

    const endpoint = `${op.conexion
      }/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=numfactura&id=${txtNumFactura.current.value.trim()}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {

            txtFecha.current.value = moment(response.data.fechafactura).format(
              "YYYY-MM-DD"
            );
            txtNumFactura.current.setAttribute("disabled", true);
            cmbRif.current.value = response.data.tiporifc;
            txtRif.current.value = response.data.rifc;
            txtNombreC.current.value = response.data.nombrec;
            txtDireccioncliente.current.value = response.data.direccionc;
            txtIdcliente.current.value = response.data.idcliente;

            for (let i = 0; i < combomoneda.length; i++) {
              if (response.data.idmoneda === combomoneda[i].idmoneda) {
                cmbMoneda.current.selectedIndex = i;
                break;
              }
            }

            if (
              response.data.numnotaentrega === "" ||
              response.data.numnotaentrega === null
            ) {
              setVisible(0);
              if (operacion === 2) {
                setHabilitadoMod(true);
                setHabilitadoCli(true);
                setHabilitadoProductos(false);
                setHabilitarMoneda(true);
              } else {
                setHabilitadoMod(false);
                setHabilitadoCli(false);
                setHabilitadoProductos(true);
              }
            }

            setHabilitarCat(true);
            setFactura({
              idfactura: response.data.idfactura,
              numfactura: response.data.numfactura,
              cedularif: response.data.cedularif,
              descripcion: response.data.descripcion,
              totalmonto: response.data.totalmonto,
              totaliva: response.data.totaliva,
              totaldescuento: response.data.totaldescuento,
              totalexento: response.data.totalexento,
              totalsujeto: response.data.totalsujeto,
              idcliente: response.data.idcliente,
              idvendedor: response.data.idvendedor,
              fecha: moment(response.data.fecha).format("YYYY-MM-DD"),
              status: response.data.status,
              idalmacen: response.data.idalmacen,
              idmoneda: response.data.idmoneda,
              idoperacioninventario: response.data.idoperacioninventario,
              idnotaentrega: response.data.idnotaentrega,
              numnotaentrega: response.data.numnotaentrega,
              creditof: response.data.creditof,
              fechavencimientof: moment(response.data.fechavencimientof).format(
                "YYYY-MM-DD"
              ),
              valormoneda: response.data.valormoneda,
            });

            setMoneda({
              idmoneda: response.data.idmoneda,
              descripcion: response.data.descripcion,
              simbolo: response.data.simbolo,
              valormoneda: response.data.valormoneda,
              predeterminada: response.data.predeterminada,
              subpredeterminada: response.data.subpredeterminada,
            });

            setVendedor({
              idvendedor: response.data.idvendedor,
              tiporif: response.data.tiporifv,
              rif: response.data.rifv,
              nombre: response.data.nombrev,
              idalmacen: response.data.idalmacen,
            });

            setTotales({
              subtotal: response.data.totalmonto - response.data.totaliva,
              descuento: response.data.totaldescuento,
              exento: response.data.totalexento,
              sujeto: response.data.totalsujeto,
              iva: 16.0,
              totaliva: response.data.totaliva,
              total: response.data.totalmonto,
            });

            seleccionarDetalleFactura(response.data.idfactura);
            setHabilitadoTip(false);
            if (operacion === 2) {
              setHabilitado(true);
              setTimeout(() => txtFecha.current.focus(), 200);
            } else {
              setHabilitado(false);
              setTimeout(() => btnCancela.current.focus(), 200);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe una Facturas con ese codigo.",
              icono: "informacion",
            });
            txtNumFactura.current.value = "";
            txtNumFactura.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalleFactura = (idfactura) => {
    let nomtab1 = "facturadetalle";
    let nomtab2 = "factura";
    let nomid = "idfactura";
    let endpoint = `${op.conexion}/api/inventario/seleccionarfacturadeta?id=${idfactura}&nomtab1=${nomtab1}&nomtab2=${nomtab2}&nomid=${nomid}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let prod = [];
            let uni = [];
            let montoiva = 0.0;
            let totalivasc = 0.0;
            let tipouni = 0;
            let tiene_iva = false;

            for (let i = 0; i < response.data.length; i++) {
              if (parseFloat(response.data[i].iva) > 0.0) {
                tiene_iva = true;
              }
              if (
                response.data[i].tipounidad === 0 &&
                parseFloat(response.data[i].valorfactor) <= 0.0
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];
              } else if (
                response.data[i].tipounidad === 0 &&
                parseFloat(response.data[i].valorfactor) > 0.0
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                  {
                    idunidad: response.data[i].idunidadalterna,
                    descripcion: response.data[i].descripcionunialt,
                    tipo: "alterna",
                  },
                ];
              } else if (response.data[i].tipounidad === 1) {
                tipouni = 1;
                uni = [
                  {
                    idunidad: response.data[i].idunidadalterna,
                    descripcion: response.data[i].descripcionunialt,
                    tipo: "alterna",
                  },
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];
              }

              montoiva = (response.data[i].punitariobs * response.data[i].iva) / 100;

              totalivasc = montoiva * response.data[i].cantidad;

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                nombre: `${response.data[i].nombrecorto} ${tiene_iva ? "" : " (E)"}`,
                iva: response.data[i].iva,
                precio: response.data[i].punitariobs,
                cantidad: response.data[i].cantidad,
                totalivas: totalivasc,
                totalsiniva: round(response.data[i].punitariobs * response.data[i].cantidad, 2),
                totalmonto: round(response.data[i].punitariobs * response.data[i].cantidad + totalivasc, 2),
                tipounidad: tipouni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                unidad: uni,
                valorfactor: response.data[i].valorfactor
              });
            }
            setRecords(prod);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/inventario/actualizarfacturanota/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " + response.data.idfactur + " creado correctamente",
              icono: "exito",
            });

            var reporte = "Factura";
            let idnot = response.data.idfactur;

            window.open(
              op.reportes +
              "/ventas?afiliado=" +
              afiliado +
              "&reporte=" +
              reporte +
              "&idnota=" +
              idnot,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.idfactur +
                " modificado correctamente",
              icono: "exito",
            });
            var reporte = "Factura";
            let idnot = response.data.idfactur;

            window.open(
              op.reportes +
              "/ventas?afiliado=" +
              afiliado +
              "&reporte=" +
              reporte +
              "&idnota=" +
              idnot,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data.idfactur +
                " eliminado correctamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const validarCantidadP = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let cantidades = validarCantidadTres({
        index: index,
        event: event,
        productos: records,
      });
      if (event.which === 13) {
        if (index < cantidades.data.length - 1) {
          setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
        }
      }
      setMensaje(cantidades.msm);
      setRecords(cantidades.data);
      setTotales(cantidades.totales);
    }
  };

  const validarPrecio = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let montoprecio = validarPrecioMontos({
        index: index,
        event: event,
        productos: records
      });
      if (event.which === 13) {
        if (index < montoprecio.data.length - 1) {
          setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
        }
      }
      setMensaje(montoprecio.msm);
      setRecords(montoprecio.data);
      setTotales(montoprecio.totales);
    }
  };

  const validarIdProducto = (index) => (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
          seleccionarProducto(index, vendedor.idalmacen, event.target.value);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación.",
            texto: "debe seleccionar un vendedor.",
            icono: "informacion",
          });
        }
      }
    }
  };

  const onCatalogoFactura = (values) => {
    setCatalogoFactura(false);
    txtNumFactura.current.value = values.numfactura;
    seleccionarFactura();
  };

  const onCatalogoNotaEntrega = (values) => {
    setCatalogoNota(false);
    txtIdcliente.current.value = values[0].idcliente;
    cmbRif.current.value = values[0].rif.substring(0, 1);
    txtRif.current.value = values[0].rif.substring(1, 12);
    txtNombreC.current.value = values[0].cliente;
    txtDireccioncliente.current.value = values[0].direccion;
    seleccionarNotaEntrega(values);
  };

  const agregarProducto = (producto) => {
    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
    setMostrar(false);
  };

  const seleccionarxIndice = (index) => (e) => {
    e.preventDefault();
    if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
      setMostrar(true);
      setIndice(index);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "debe seleccionar un vendedor.",
        icono: "informacion",
      });
    }
  };

  const eliminarProducto = (producto) => (e) => {
    e.preventDefault();
    let data = [...records];
    let elementos = [];

    for (let i = 0; i < data.length; i++) {
      if (producto.idproducto !== data[i].idproducto) {
        elementos.push(data[i]);
      }
    }
    setRecords(elementos);
    setTotales(calcularTotalesDos(elementos));
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    const cambio = onCambioMoneda({
      moneda: combomoneda[i],
      productos: records,
      monedaPre: moneda,
      monedaSub: monedaSub,
    });
    setMonedaCambio(cambio.monedacambio);
    setRecords(cambio.data);
  };

  const onChangeUnidad = (i) => (e) => {
    let cambiounidad = onCambioUnidadTres({
      idunidad: e.target.value,
      index: i,
      productos: records,
    });
    setMensaje(cambiounidad.msm);
    setRecords(cambiounidad.data);
    setTotales(cambiounidad.totales);
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (
      cmbRif.current.value === "" ||
      txtRif.current.value.trim() === "" ||
      txtNombreC.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Cliente no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Producto agregados",
        icono: "informacion",
      });
      sigue = false;
      btnCancela.current.focus();
    } else if (records.length > 0 && operacion !== 3) {
      for (let i = 0; i < records.length; i++) {
        if (factura.numnotaentrega === "" || factura.numnotaentrega === null) {
          if (records[i].cantidadE === 0.0) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La  cantidad no debe ser mayor a la cantidad existente",
              icono: "informacion",
            });
            sigue = false;
            btnCancela.current.focus();
            break;
          } else if (records[i].cantidadE < records[i].cantidad) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La  cantidad no debe ser mayor a la cantidad existente",
              icono: "informacion",
            });
            sigue = false;
            btnCancela.current.focus();
            break;
          }
        }
      }
    }

    if (sigue) {
      let fact = [];
      let factdet = [];

      fact.push({
        idfactura: factura.idfactura,
        numfactura: txtNumFactura.current.value.trim(),
        descripcion: "FACTURA DE PRODUCTOS",
        cedularif: cmbRif.current.value.trim() + txtRif.current.value.trim(),
        totalmonto: totales.total,
        totaliva: totales.totaliva,
        totalexento: totales.exento,
        totalsujeto: totales.sujeto,
        totaldescuento: totales.descuento,
        ...(factura.idnotaentrega !== "" &&
          factura.idnotaentrega !== null && {
          idnotaentrega: factura.idnotaentrega,
        }),
        idcliente: txtIdcliente.current.value,
        idvendedor: idVendedor,
        fecha: txtFecha.current.value,
        status: 1,
        idalmacen: 0,
        idmoneda: 1,
        idoperacioninventario: "",
        creditof: 0.00,
        fechavencimientof: "",
        tipofactu: "NO"
      });

      for (let i = 0; i < records.length; i++) {
        factdet.push({
          idproducto: records[i].idproducto,
          cantidad: records[i].cantidad,
          punitario: round(records[i].precio / monedaSub.valormoneda, 2),
          punitariobs: records[i].precio,
          descuento: "0.00",
          iva: records[i].iva,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
          tasa: monedaSub.valormoneda,
          codproducto: records[i].codigo,
          costo: records[i].precio,
          utilidad: 0.00,
          tipopreciodeta: 0,
        });
      }

      setBody({
        factur: fact,
        facturdet: factdet,
        idtipopeinv: "2",
        opeinv: [],
        opeinvdet: [],
        idsnotas: idsnotas
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Facturas.");
    setBody();
    setActivate(false);
    txtNumFactura.current.value = "";
    setHabilitado(false);
    setHabilitadoMod(false);
    setHabilitadoTip(false);
    setHabilitarMoneda(false);
    setHabilitadoCli(false);
    setHabilitadoBot(true);
    setHabilitarCat(true);
    setHabilitadoProductos(true);
    setVisible(0);
    setSelectp(0);
    setSelectd(0);
    setVisibleBtn("visible");
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    setMonedaCambio({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: true,
      subpredeterminada: false,
      valormoneda: 1.0,
    });
    setRecords([]);
    for (let i = 0; i < combomoneda.length; i++) {
      if (combomoneda[i].idmoneda === moneda.idmoneda) {
        cmbMoneda.current.selectedIndex = i;
      }
    }
    txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
    cmbRif.current.value = "J";
    txtRif.current.value = "";
    txtNombreC.current.value = "";
    txtDireccioncliente.current.value = "";
    setCliente({
      idcliente: "",
      tiporif: "J",
      rif: "",
      nombre: "",
    });
    setVendedor({
      idvendedor: "",
      tiporif: "",
      rif: "",
      nombre: "",
      idalmacen: "",
    });
    setFactura({
      idfactura: "0",
      numfactura: "000000",
      cedularif: "",
      descripcion: "FACTURAS DE PRODUCTOS",
      totalmonto: 0.0,
      totaliva: 0.0,
      totaldescuento: 0.0,
      totalexento: 0.0,
      totalsujeto: 0.0,
      idcliente: "",
      idvendedor: "",
      fecha: moment(fechasistema).format("YYYY-MM-DD"),
      status: 0,
      idalmacen: "",
      idmoneda: "",
      idoperacioninventario: "",
      idnotaentrega: "",
      numnotaentrega: "",
      creditof: false,
      fechavencimientof: moment(fechasistema).format("YYYY-MM-DD"),
      valormoneda: 0.0,
    });
    setTotales({
      subtotal: 0.0,
      descuento: 0.0,
      exento: 0.0,
      sujeto: 0.0,
      iva: 16.0,
      totaliva: 0.0,
      total: 0.0,
    });
    setOperacion(0);
    setIdnotas([]);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleInputChangeCodigo = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "numnotaentrega") {
          seleccionarNotaEntrega();
        } else if (event.target.name === "numfactura") {
          seleccionarFactura();
        }
      }
    }
  };

  const onChange = (e) => {
    if (e.target.name === "tipopago") {
      if (e.target.value === "1") {
        setSelectd(0);
        setFactura({
          ...factura,
          creditof: false,
          fechavencimientof: "",
        });
        txtFechaVencimiento.current.value = "";
      } else if (e.target.value === "2") {
        setSelectd(1);
        setFactura({
          ...factura,
          creditof: true,
          fechavencimientof: moment(fechasistema).format("YYYY-MM-DD"),
        });
        txtFechaVencimiento.current.value =
          moment(fechasistema).format("YYYY-MM-DD");
      }
    } else if (e.target.name === "desde") {
      if (e.target.value === "2") {
        setSelectp(1);
        setVisible(1);
        setHabilitadoCli(false);
        setHabilitadoProductos(true);
      } else if (e.target.value === "1") {
        setSelectp(0);
        setVisible(0);
        setHabilitadoCli(true);
        setHabilitadoProductos(false);
      }
    } else if (e.target.name === "fecha") {
      setFactura({ ...factura, fecha: e.target.value });
    } else if (e.target.name === "fechavencimiento") {
      setFactura({ ...factura, fechavencimientof: e.target.value });
    }
  };

  const imprimirFactura = () => {
    if (accbtnfacturas && accbtnfacturas.toString().substring(4, 5) === "1") {
      let fact = 0;
      if (txtNumFactura.current.value !== "") {
        let idnot = factura.idfactura;

        var reporte = "Factura";

        window.open(
          op.reportes +
          "/ventas?afiliado=" +
          afiliado +
          "&reporte=" +
          reporte +
          "&idnota=" +
          idnot,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione la Factura !",
          icono: "informacion",
        });
        fact = 1;
      }

      if (fact === 1) {
        txtNumFactura.current.focus();
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (accbtnfacturas && accbtnfacturas.toString().substring(0, 1) === "1") {
        setTituloHeader("Incluir Facturas.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitadoTip(true);
        setHabilitadoMod(true);
        setHabilitado(true);
        setHabilitadoCli(true);
        setHabilitadoProductos(false);
        setHabilitarMoneda(true);
        selectnumfactu();
        seleccionarVendedor(idVendedor);
        setHabilitarCat(true);
        txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (accbtnfacturas && accbtnfacturas.toString().substring(1, 2) === "1") {
        setTituloHeader("Editar Facturas.");
        setOperacion(op);
        //txtNumFactura.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setTimeout(() => txtNumFactura.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (accbtnfacturas && accbtnfacturas.toString().substring(3, 4) === "1") {
        setTituloHeader("Eliminar Facturas.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitarCat(false);
        setHabilitadoTip(false);
        setHabilitarMoneda(false);
        setHabilitadoMod(false);
        setHabilitado(false);
        setHabilitadoCli(false);
        setHabilitadoProductos(true);
        setTimeout(() => txtNumFactura.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (accbtnfacturas && accbtnfacturas.toString().substring(2, 3) === "1") {
        setTituloHeader("Consultar Facturas.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitarCat(false);
        setHabilitado(false);
        setHabilitadoTip(false);
        setHabilitarMoneda(true);
        setHabilitadoMod(false);
        setHabilitadoCli(false);
        setHabilitadoProductos(true);
        setTimeout(() => txtNumFactura.current.focus(), 200);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  useEffect(() => {
    seleccionarMonedas();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-11 mx-auto py-2 card shadow">
            <div className="col-md-12 row border-azul mx-auto rounded py-1">
              <div className="col-md-12 row mx-auto d-flex justify-content-between mb-1">
                <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between">
                  <div className="col-md-4">
                    <h3>{tituloHeader}</h3>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end">
                    <a href="/inicio" className="text-light ">
                      <i className="fas fa-times mx-2"></i>
                      <span className="fw-bold">Salir</span>
                    </a>
                  </div>
                </div>



                <div
                  className="colfull col-pd-300 mb-3"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      N° FACTURA:
                    </label>
                    <input
                      type="text"
                      disabled={operacion !== 0 ? false : true}
                      autoComplete="off"
                      ref={txtNumFactura}
                      name="numfactura"
                      onKeyUp={operacion !== 1 ? handleInputChangeCodigo : null}
                      onBlur={operacion !== 1 ? handleInputChangeCodigo : null}
                      onChange={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    {operacion !== 1 && (
                      <button
                        disabled={habilitarCat}
                        type="button"
                        onClick={() => setCatalogoFactura(true)}
                        className="btn btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>)}
                  </div>
                </div>



                <div
                  className="colfull col280 mr-auto mb-3 px-1"
                  style={{ fontSizeAdjust: "0.6" }}
                >
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOTA ENTREGA:
                    </label>
                    <button
                      type="button"
                      disabled={!habilitadoTip}
                      onClick={() => setCatalogoNota(true)}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div className="colfull col-pd-290 mb-3">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO MONEDA:
                    </label>
                    <select
                      className="form-control form-control-sm fw-bold text-center"
                      disabled={!habilitarMoneda}
                      ref={cmbMoneda}
                      onChange={onChangeMoneda}
                    >
                      {combomoneda &&
                        combomoneda.map((item, index) => (
                          <option key={index} value={index}>
                            {" "}
                            {`${item.descripcion} ${item.simbolo
                              } ${formatMoneda(
                                item.valormoneda
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}`}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-pd-220 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:
                    </label>
                    <input
                      type="date"
                      disabled={!habilitado}
                      ref={txtFecha}
                      name="fecha"
                      onChange={onChange}
                      className="form-control fs-6 text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>

              <div
                className="colfull1070 col-sm-12 mx-auto mb-1 row m-0"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded py-2">
                  <span className="fw-bold mb-1">Datos del Cliente</span>
                  <div className="input-group input-group-sm mb-2 col-3 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled={true}
                      className="form-select form-select-sm col-md-3 text-center"
                      aria-label=".form-select-sm example"
                    >
                      {cmbCedula.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.value}
                        </option>
                      ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled={true}
                      maxLength={9}
                      type="text"
                      className="form-control fs-6"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <input type="hidden" ref={txtIdcliente} />
                  <div className="input-group input-group-sm mb-2 col-9">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      ref={txtNombreC}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCIÓN:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      ref={txtDireccioncliente}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>

              <div
                className="col-md-12 border-azul px-0 rounded"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 300,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className="bg-light d-flex align-items-between px-0">
                            <input
                              type="text"
                              style={{
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0,
                              }}
                              disabled={habilitadoProductos}
                              ref={(el) => (txtId.current[index] = el)}
                              className="form-control form-control-sm bg-light fs-6"
                              defaultValue={item.codigo}
                              onChange={(e) =>
                                (e.target.value = e.target.value.toUpperCase())
                              }
                              onKeyUp={validarIdProducto(index)}
                              onBlur={validarIdProducto(index)}
                            />
                            {(operacion === 1 ||
                              operacion === 2 ||
                              factura.numnotaentrega !== "") && (
                                <button
                                  type="button"
                                  style={{
                                    borderBottomLeftRadius: 0,
                                    borderTopLeftRadius: 0,
                                  }}
                                  disabled={habilitadoProductos}
                                  onClick={seleccionarxIndice(index)}
                                  className="btn btn-sm btn-primary"
                                >
                                  <i className="fas ">-</i>
                                </button>
                              )}
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light text-start p-0 pl-2"
                            style={{ width: "250px" }}
                          >
                            {item.nombre}
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light text-center p-0"
                            style={{ width: "20px" }}
                          >
                            <div className="col-12 row m-0 px-0">
                              <input
                                type="text"
                                className="form-control form-control-sm bg-light text-right fs-6 col-6"
                                id="cantidad"
                                disabled={!habilitadoMod}
                                defaultValue={formatMoneda(
                                  item.cantidad
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                                ref={(el) => (txtCantidad.current[index] = el)}
                                onFocus={seleccionarCampo}
                                onKeyUp={validarCantidadP(index)}
                                onBlur={validarCantidadP(index)}
                                aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm"
                              />
                              <select
                                className="form-control form-control-sm fs-6 col-6"
                                style={{ width: "100%" }}
                                disabled={habilitadoProductos}
                                onChange={onChangeUnidad(index)}
                              >
                                {item.unidad &&
                                  item.unidad.map((item2, x) => (
                                    <option key={x} value={item2.idunidad}>
                                      {" "}
                                      {item2.descripcion}{" "}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light p-0 text-right"
                            style={{ width: 50 }}
                          >
                            <input
                              type="text"
                              disabled={operacion === 2 || operacion === 1 ? false : true}
                              onKeyUp={validarPrecio(index)}
                              onBlur={validarPrecio(index)}
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="precio"
                              defaultValue={formatMoneda(
                                item.precio
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtPrecio.current[index] = el)}
                            />
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.iva)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.totalivas)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "50px" }}
                          >
                            {formatMoneda(
                              (item.totalmonto)
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          {operacion !== 4 && operacion !== 3 && (
                            <TableCell
                              className="align-middle bg-light text-center p-0"
                              style={{ width: "20px" }}
                            >
                              <button
                                disabled={habilitadoProductos}
                                style={{
                                  visibility:
                                    (operacion === 4 || operacion === 3) &&
                                    "collapse",
                                }}
                                onClick={eliminarProducto(item)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    <TableRow
                      style={{
                        padding: "0",
                        visibility:
                          (operacion === 4 ||
                            operacion === 0 ||
                            operacion === 3) &&
                          "collapse",
                      }}
                    >
                      <TableCell className="align-middle bg-light text-center p-0 d-flex">
                        <input
                          type="text"
                          disabled={habilitadoProductos}
                          ref={txtIdproducto}
                          style={{
                            borderBottomRightRadius: 0,
                            borderTopRightRadius: 0,
                          }}
                          className="form-control form-control-sm bg-light text-right"
                          onChange={(e) =>
                            (e.target.value = e.target.value.toUpperCase())
                          }
                          onKeyUp={validarIdProducto(null)}
                          onBlur={validarIdProducto(null)}
                        />
                        <button
                          type="button"
                          disabled={habilitadoProductos}
                          style={{
                            borderBottomLeftRadius: 0,
                            borderTopLeftRadius: 0,
                          }}
                          onClick={() => setMostrar(true)}
                          className="btn btn-sm btn-primary"
                        >
                          <i className="fas ">-</i>
                        </button>
                      </TableCell>
                      <TableCell
                        className="align-middle bg-light text-start p-0 pl-2"
                        style={{ width: "250px" }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light text-end p-0 pr-2"
                        style={{ width: "50px" }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light text-end p-0 pr-2"
                        style={{ width: "50px" }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light p-0"
                        style={{ width: 50 }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light p-0"
                        style={{ width: 50 }}
                      ></TableCell>
                      <TableCell
                        className="align-middle bg-light text-end p-0"
                        style={{ width: "50px" }}
                      ></TableCell>
                      {operacion === 4 || operacion === 3 ? (
                        ""
                      ) : (
                        <TableCell
                          className="align-middle bg-light text-center p-0"
                          style={{ width: "20px" }}
                        ></TableCell>
                      )}
                    </TableRow>
                  </TableBody>
                </TblContainer>
              </div>
              <div className="col-md-12 row m-0 px-0">
                <div className="col-md-7 py-1 mt-auto">
                  {visibleBtn === "visible" ? (
                    <div className="col-pd-botones">
                      <div className="col-md-12 row m-0">
                        <button
                          disabled={!habilitadoBot}
                          ref={btnIncluir}
                          onClick={onBotones(1)}
                          className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                          title="Incluir Factura"
                        >
                          <i className="fas fa-plus"> Incluir </i>{" "}
                        </button>
                        <button
                          disabled={!habilitadoBot}
                          ref={btnConsultar}
                          onClick={onBotones(4)}
                          className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                          title="Consultar Factura"
                        >
                          <i className="fas fa-eye"> Consultar</i>{" "}
                        </button>
                        <button
                          disabled={!habilitadoBot}
                          ref={btnEditar}
                          onClick={onBotones(2)}
                          className="btn btn-sm col ml-1 mb-1 btn-warning rounded-pill"
                          title="Modificar Factura"
                        >
                          <i className="fa fa-edit"> Modificar</i>{" "}
                        </button>
                        <button
                          disabled={!habilitadoBot}
                          ref={btnEliminar}
                          onClick={onBotones(3)}
                          className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                          title="Eliminar Factura"
                        >
                          <i className="fa fa-trash"> Eliminar</i>{" "}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="col-pd-360 row m-0 ml-auto">
                      {operacion === 4 ? (
                        <button
                          onClick={imprimirFactura}
                          disabled={operacion === 4 ? false : true}
                          className="btn btn-sm col ml-1 btn-primary rounded-pill"
                          title="Imprimir Factura"
                        >
                          <i className="fa fa-print"> Imprimir</i>
                        </button>
                      ) : (
                        ""
                      )}

                      <button
                        ref={btnAcepta}
                        disabled={operacion === 4 ? true : habilitadoBot}
                        onClick={onBotones(5)}
                        className="btn btn-sm col ml-1 rounded-pill btn-success"
                      >
                        <i className="fas fa-check-circle"> Aceptar</i>
                      </button>
                      <button
                        ref={btnCancela}
                        disabled={habilitadoBot}
                        onClick={onBotones(6)}
                        className="btn btn-danger col ml-1 btn-sm rounded-pill"
                      >
                        <i className="fas fa-window-close"> Cancelar</i>
                      </button>
                    </div>
                  )}
                </div>
                <div
                  className="col-md-5 border-azul rounded shadow"
                  style={{ backgroundColor: "#dbeeff" }}
                >
                  <div
                    className="input-group input-group-sm col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      SUBTOTAL {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtSubTotal}
                      value={formatMoneda(
                        (totales.subtotal)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      EXENTO {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtExentoTotal}
                      value={formatMoneda(
                        (totales.exento)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      DESCUENTO {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtDescuento}
                      value={formatMoneda(
                        (totales.descuento)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      IVA {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtTotIva}
                      value={formatMoneda(
                        (totales.totaliva)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div
                    className="input-group input-group-sm  col-md-12"
                    style={{ fontSizeAdjust: "0.6" }}
                  >
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                      style={{ fontSize: 14 }}
                    >
                      TOTAL {monedaCambio.simbolo}:
                    </label>

                    <input
                      type="text"
                      disabled
                      ref={txtTotal}
                      value={formatMoneda(
                        (totales.total)
                          .toString()
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                      className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CatalogoProductoExistencia
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAceptaCatalogo={agregarProducto}
        idalmacen={vendedor.idalmacen}
      />
      <CatalogoNotaEntregaFacturas
        show={catalogoNota}
        nomid="notaentrega"
        tip={"FA"}
        tipo="NE"
        onHideCancelar={() => setCatalogoNota(false)}
        onHideAceptaCatalogo={onCatalogoNotaEntrega}
        condicion="status != 4"
      />
      <CatalogoFactura
        show={catalogoFactura}
        tipofactu="factu"
        onHideCancelar={() => setCatalogoFactura(false)}
        onHideAceptaCatalogo={onCatalogoFactura}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaFacturaxNota;



// WEBPACK FOOTER //
// ./src/components/ventas/tablaFacturaxNota.js